import React from 'react';
import Lottie from 'react-lottie';
import animationData from '../assets/animations/menu-bg.json'; 

const Loading = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  return (

    <div className="bg-light loading-container">
            <div className="loading-bar"></div>
      <div className="loading-content">

        {/* <p className='text-light fs-3 fw-bold '>Loading...</p> */}
        {/* <Lottie options={defaultOptions} height={"auto"} width={150} /> */}
      </div>
    </div>
  );
};

export default Loading;